import React, { useContext } from "react";
import { Button } from "../../../../controls";
import { useNavigate } from "react-router-dom";
import { NestedMenu } from "layout";
import { action, API, controller } from "api";
import { ToFormData } from "hooks";
import { AppContext } from "App";

const Header = ({
  handleAddEdit,
  selectedRec,
  handleUpdatePrices,
  handleStatus,
  setAlert,
  handleBCST,
}) => {
  const { access } = useContext(AppContext);
  const navigate = useNavigate();

  const handleImportCatalog = () => {
    navigate("/import_catalog");
  };

  const handleDeleteSelectedProds = () => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: `You're about to delete ${selectedRec?.items.length} products`,
      subTitle:
        "Once deleted, you will no longer be able to edit these products. Retail prices and inventory levels will also be deleted. This can’t be undone.",
      confirmBtnTitle: "Delete Products",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res) {
            if (res.status === 200) {
              setAlert({
                isOpen: true,
                type: "success",
                title: "Deleted Successfully",
                subTitle: "You have successfully deleted all of the products",
                onClick: () => {
                  navigate(0);
                },
              });
            } else
              setAlert({
                isOpen: true,
                type: "warning",
                title: "Products Deleted (Some Skipped)",
                htmlSubtitle: <SkippedProdAlert values={res.result} />,
                onClick: () => {
                  navigate(0);
                },
              });
          }
        };
        API(controller.Product + action.DeleteSelectedProds).post(
          ToFormData({
            all: selectedRec?.all,
            ids: selectedRec?.items,
          }),
          onComplete
        );
      },
    });
  };

  const handleRemoveBCST = (type) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: `Remove ${type} from ${selectedRec?.items.length} products`,
      subTitle: `Any ${type} will be removed from the products in this group. This action can’t be undone.`,
      confirmBtnTitle: `Remove ${type}`,
      onConfirm: () => {
        const onComplete = (res) => {
          if (res) {
            if (res.status === 200)
              setAlert({
                isOpen: true,
                type: "success",
                title: "Removed Successfully",
                subTitle: res?.msg,
                onClick: () => {
                  navigate(0);
                },
              });
          }
        };
        API(controller.Product + action.RemoveBCST).post(
          ToFormData({
            all: selectedRec?.all,
            ids: selectedRec?.items,
            type: type,
          }),
          onComplete
        );
      },
    });
  };

  return (
    <div className="flex flex-wrap gap-[10px]">
      {access?.catalog?.create && (
        <Button onClick={() => handleAddEdit()}>Add Product</Button>
      )}
      {access?.catalog?.import && (
        <Button onClick={handleImportCatalog} variant="text">
          Import Product
        </Button>
      )}

      {selectedRec?.items.length > 0 && (
        <NestedMenu
          label={`Choose an action (${selectedRec?.items.length} selected)`}
          menus={[
            ...(access.catalog?.status
              ? [
                  {
                    title: "Active Products",
                    onClick: () => handleStatus(true),
                  },
                  {
                    title: "Deactive Products",
                    onClick: () => handleStatus(false),
                  },
                ]
              : []),
            ...(access.catalog?.delete
              ? [
                  {
                    title: "Delete Products",
                    onClick: () => handleDeleteSelectedProds(),
                  },
                ]
              : []),
            {
              title: "Update Products",
              child: [
                ...(access.catalog?.edit
                  ? [
                      {
                        title: "Edit Prices",
                        onClick: () => handleUpdatePrices(),
                      },
                    ]
                  : []),
                {
                  title: "Brands",
                  child: [
                    ...(access.catalog?.edit
                      ? [
                          {
                            title: "Update",
                            onClick: () => handleBCST("brand"),
                          },
                        ]
                      : []),
                    ...(access.catalog?.delete
                      ? [
                          {
                            title: "Remove",
                            onClick: () => handleRemoveBCST("brands"),
                          },
                        ]
                      : []),
                  ],
                },
                {
                  title: "Categories",
                  child: [
                    ...(access.catalog?.edit
                      ? [
                          {
                            title: "Update",
                            onClick: () => handleBCST("category"),
                          },
                        ]
                      : []),
                    ...(access.catalog?.delete
                      ? [
                          {
                            title: "Remove",
                            onClick: () => handleRemoveBCST("categories"),
                          },
                        ]
                      : []),
                  ],
                },
                {
                  title: "Suppliers",
                  child: [
                    ...(access.catalog?.edit
                      ? [
                          {
                            title: "Update",
                            onClick: () => handleBCST("supplier"),
                          },
                        ]
                      : []),
                    ...(access.catalog?.delete
                      ? [
                          {
                            title: "Remove",
                            onClick: () => handleRemoveBCST("suppliers"),
                          },
                        ]
                      : []),
                  ],
                },
                {
                  title: "Tags",
                  child: [
                    ...(access.catalog?.edit
                      ? [{ title: "Update", onClick: () => handleBCST("tag") }]
                      : []),
                    ...(access.catalog?.delete
                      ? [
                          {
                            title: "Remove",
                            onClick: () => handleRemoveBCST("tags"),
                          },
                        ]
                      : []),
                  ],
                },
              ],
            },
          ]}
        />
      )}
    </div>
  );
};

export default Header;

const SkippedProdAlert = ({ values }) => (
  <div className="flex flex-col gap-3 text-start">
    {values.deletedProds?.length > 0 && (
      <span>
        ✅ You have succcessfully deleted {values.deletedProds.length} products
      </span>
    )}
    <span>
      ⚠️ You can't delete these {values.skippedProds.length} products, for
      linked to sales or other records.
    </span>

    <div>
      {values.skippedProds.map((label, ind) => (
        <div key={ind}>
          <span className="text-[14px] text-gray-500">* {label}</span>
        </div>
      ))}
    </div>
  </div>
);
